import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-start 2xl:items-center 2xl:space-x-3" }

import { ref, computed } from "vue";
import { useRouter } from 'vue-router';
import { hasPermission } from "@/classes/AuthService";
import { useNetworkStore } from "@/store/network";

import { RoleTypes } from "@/views/enums/RoleTypes"
import Storage from "@/helpers/storage";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationLink',
  props: {
    status: {
        default: true,
        type: Boolean
    }
},
  setup(__props) {

const tokens = new Storage();

const user = JSON.parse(tokens.get("user"));

const networkStore = useNetworkStore();
const isNetworkAvailable = computed(() => networkStore.isNetworkAvailable);

const router = useRouter();
const currentRouteName = router.currentRoute.value.name;



const gotoDashboard = ():void =>{
    const wcpuRoles = [
        RoleTypes.OFFICE_ADMIN,
        RoleTypes.OFFICE_NORMAL,
        RoleTypes.NURSE,
        RoleTypes.WCPU,
        RoleTypes.OFFICE_TRAINEE,
    ]

    if(wcpuRoles.includes(user.role_id)){
        window.location.href = "/dashboard/wcpu";
    } else {
        window.location.href = "/dashboard";
    }
}

const canViewOffice = () => {
    if (user.role_id == RoleTypes.SUPERADMIN || user.role_id == RoleTypes.SUPERADMIN_IT || user.role_id == RoleTypes.AUDITOR || user.role_id == RoleTypes.OFFICE_ADMIN) {
        return true;
    }

    return false;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isNetworkAvailable.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.status)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (gotoDashboard())),
                class: _normalizeClass(["2xl:block flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", _unref(currentRouteName) == 'DashboardIndex' ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' : '2xl:bg-primary-600 2xl:font-semibold opacity-70'])
              }, " Dashboard ", 2))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(hasPermission)('can-search-patients'))
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/patient/search'))),
          class: _normalizeClass(["2xl:block flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", 
                _unref(currentRouteName) == 'PatientSearchForm' ||
                _unref(currentRouteName) == 'PatientIndex' ||
                _unref(currentRouteName) == 'PatientEdit' ||
                _unref(currentRouteName) == 'PatientView' ||
                _unref(currentRouteName) == 'PatientCreate' ||
                _unref(currentRouteName) == 'PatientProfileEdit' ||
                _unref(currentRouteName) == 'PatientGuardianCreate' ||
                _unref(currentRouteName) == 'PatientGuardianEdit' ||
                _unref(currentRouteName) == 'PatientCompanionCreate' ||
                _unref(currentRouteName) == 'PatientCompanionEdit' ||
                _unref(currentRouteName) == 'PatientAddressCreate' ||
                _unref(currentRouteName) == 'PatientAddressEdit' ||
                _unref(currentRouteName) == 'PatientPerpetratorSearch' ||
                _unref(currentRouteName) == 'PatientPerpetratorIndex' ||
                _unref(currentRouteName) == 'PatientPerpetratorCreate' ||
                _unref(currentRouteName) == 'PatientIntakeCreate' ||
                _unref(currentRouteName) == 'PatientIntakeView' ||
                _unref(currentRouteName) == 'PatientSafetyAssessmentCreate' ||
                _unref(currentRouteName) == 'PatientSafetyAssessmentView'
                    ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' 
                    : '2xl:bg-primary-600 2xl:font-semibold opacity-70'
            ])
        }, " Patient ", 2))
      : _createCommentVNode("", true),
    (_unref(hasPermission)('can-search-patients-intervations'))
      ? (_openBlock(), _createElementBlock("a", {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/intervention/search'))),
          class: _normalizeClass(["2xl:block flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", 
                _unref(currentRouteName) == 'InterventionSearchForm' ||
                _unref(currentRouteName) == 'InterventionIndex' ||
                _unref(currentRouteName) == 'InterventionView' ||
                _unref(currentRouteName) == 'InterventionSocialWorkCreate' ||
                _unref(currentRouteName) == 'InterventionMedicalCreate' ||
                _unref(currentRouteName) == 'InterventionMentalHealthCreate' ||
                _unref(currentRouteName) == 'InterventionDevelopmentalPediaCreate' ||
                _unref(currentRouteName) == 'InterventionLegalCreate' ||
                _unref(currentRouteName) == 'InterventionTeleconsultationCreate' ||
                _unref(currentRouteName) == 'InterventionTelepsychiatryCreate' ||
                _unref(currentRouteName) == 'InterventionAdminCreate'
                    ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' 
                    : '2xl:bg-primary-600 2xl:font-semibold opacity-70'
            ])
        }, " Intervention ", 2))
      : _createCommentVNode("", true),
    (_unref(hasPermission)('can-search-perpetrator'))
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).push('/perpetrator/index'))),
          class: _normalizeClass(["2xl:block flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", 
                _unref(currentRouteName) == 'PerpetratorIndex' ||
                _unref(currentRouteName) == 'PerpetratorEdit' ||
                _unref(currentRouteName) == 'PerpetratorView'
                    ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' 
                    : '2xl:bg-primary-600 2xl:font-semibold opacity-70'
            ])
        }, " Perpetrator ", 2))
      : _createCommentVNode("", true),
    (isNetworkAvailable.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          (_unref(hasPermission)('can-view-admins') && __props.status)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/personnel/index'))),
                class: _normalizeClass(["2xl:block md:flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", 
                    _unref(currentRouteName) == 'PersonnelIndex' ||
                    _unref(currentRouteName) == 'PersonnelView' ||
                    _unref(currentRouteName) == 'PersonnelEdit' ||
                    _unref(currentRouteName) == 'PersonnelCreate'
                        ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' 
                        : '2xl:bg-primary-600 2xl:font-semibold opacity-70'
                ])
              }, " Personnel ", 2))
            : _createCommentVNode("", true),
          (__props.status && canViewOffice())
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(router).push('/office/index'))),
                class: _normalizeClass(["2xl:block md:flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", 
                    _unref(currentRouteName) == 'OfficeIndex' ||
                    _unref(currentRouteName) == 'OfficeView' ||
                    _unref(currentRouteName) == 'OfficeCreate'
                        ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' 
                        : '2xl:bg-primary-600 2xl:font-semibold opacity-70'
                ])
              }, " Office ", 2))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    (_unref(hasPermission)('manage-data-dictionary'))
      ? (_openBlock(), _createElementBlock("a", {
          key: 5,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(router).push('/data-dictionary/index'))),
          class: _normalizeClass(["2xl:block flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", 
                _unref(currentRouteName) == 'DataDictionaryIndex' || _unref(currentRouteName) == 'DataDictionaryView'
                    ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' 
                    : '2xl:bg-primary-600 2xl:font-semibold opacity-70'
            ])
        }, " Data Dictionary ", 2))
      : _createCommentVNode("", true),
    (isNetworkAvailable.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
          (_unref(hasPermission)('can-access-report'))
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(router).push('/reports'))),
                class: _normalizeClass(["2xl:block md:flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", _unref(currentRouteName) == 'ReportsIndex' || _unref(currentRouteName) == 'ReportsView' ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' : '2xl:bg-primary-600 2xl:font-semibold opacity-70'])
              }, " Reports ", 2))
            : _createCommentVNode("", true),
          (_unref(hasPermission)('manage-primary-diagnoses') && __props.status)
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(router).push('/settings/roles/index'))),
                class: _normalizeClass(["2xl:block md:flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", 
                    _unref(currentRouteName) == 'SettingsRolesIndex' ||
                    _unref(currentRouteName) == 'SettingsRolesView' ||
                    _unref(currentRouteName) == 'SettingsPrimaryDiagnosisIndex' ||
                    _unref(currentRouteName) == 'SettingsPrimaryDiagnosisView' ||
                    _unref(currentRouteName) == 'SettingsPrimaryDiagnosisCreate' ||
                    _unref(currentRouteName) == 'SettingsFormOptionsIndex' ||
                    _unref(currentRouteName) == 'SettingsFormOptionsView' ||
                    _unref(currentRouteName) == 'SettingsFormOptionsCreate' ||
                    _unref(currentRouteName) == 'SettingsFormOptionsEdit' ||
                    _unref(currentRouteName) == 'SettingsDepartmentIndex' ||
                    _unref(currentRouteName) == 'SettingsDepartmentView' ||
                    _unref(currentRouteName) == 'SettingsDepartmentCreate' ||
                    _unref(currentRouteName) == 'SettingsTelecpuLocationsIndex' ||
                    _unref(currentRouteName) == 'SettingsTelecpuLocationsView' ||
                    _unref(currentRouteName) == 'SettingsTelecpuLocationsCreate' ||
                    _unref(currentRouteName) == 'SettingsTelecpuLocationsOfficeEdit' ||
                    _unref(currentRouteName) == 'SettingsTelecpuLocationsOfficeCreate' ||
                    _unref(currentRouteName) == 'SettingsDataDictionaryIndex' ||
                    _unref(currentRouteName) == 'SettingsDataDictionaryView' ||
                    _unref(currentRouteName) == 'SettingsDataDictionaryCreate' ||
                    _unref(currentRouteName) == 'SettingsNotificationsIndex' ||
                    _unref(currentRouteName) == 'SettingsNotificationsView'
                        ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' 
                        : '2xl:bg-primary-600 2xl:font-semibold opacity-70'
                ])
              }, " Settings ", 2))
            : _createCommentVNode("", true),
          (_unref(hasPermission)('manage-patient-log') && __props.status)
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(router).push('/patient-logs/index'))),
                class: _normalizeClass(["2xl:block flex whitespace-nowrap justify-between w-full 2xl:px-3 2xl:py-2 py-[14px] text-white 2xl:text-xs text-sm 2xl:rounded cursor-pointer", _unref(currentRouteName) == 'PatientLogsIndex' ? '2xl:bg-[#529ffc] font-semibold 2xl:border-b-0 border-b border-white' : '2xl:bg-primary-600 2xl:font-semibold opacity-70'])
              }, " Patient Logs ", 2))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})